import { unitMapping, type Unit } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = { size?: Unit; color?: Color };
export const Lineup = ({ size = 2, color }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{ height: unitMapping[size] }}
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.60088 5.72534L4.09033 4.10313L4.50167 3.72012L5.98488 5.31296L7.46809 3.72012L7.87943 4.10313L6.36888 5.72534L7.85569 7.32206L7.44436 7.70508L5.98488 6.13772L4.52541 7.70508L4.11407 7.32206L5.60088 5.72534Z"
      fill={color}
      fillOpacity="0.66"
    />
    <path
      d="M8.40015 1.5C8.73124 1.50014 9.00047 1.76855 9.00073 2.09961V9.89941C9.0007 10.2307 8.73139 10.4999 8.40015 10.5H3.67554C3.34418 10.5 3.07498 10.2308 3.07495 9.89941V2.09961C3.07521 1.76846 3.34433 1.5 3.67554 1.5H8.40015ZM2.40015 3.2998H1.80054V8.77539H2.40015V9.97461H1.19995C0.86873 9.97452 0.600461 9.70621 0.600342 9.375V2.7002C0.600342 2.36888 0.868657 2.0997 1.19995 2.09961H2.40015V3.2998ZM10.8005 2.09961C11.1317 2.09986 11.4001 2.36898 11.4001 2.7002V9.375C11.4 9.70611 11.1316 9.97436 10.8005 9.97461H9.60034V8.77539H10.2V3.2998H9.60034V2.09961H10.8005ZM4.27515 3.11328L3.92554 3.10156L3.5144 3.48535L3.47241 4.67871L4.27515 5.54102V5.9082L3.49585 6.74609L3.53882 7.94043L3.94995 8.32324L4.27515 8.31152V9.2998H7.80054V8.31543L8.02026 8.32324L8.4314 7.94043L8.47437 6.74609L7.80054 6.02246V5.42676L8.4978 4.67871L8.45483 3.48535L8.0437 3.10156L7.80054 3.10938V2.7002H4.27515V3.11328ZM4.27515 7.47168L4.11401 7.32227L4.27515 7.14844V7.47168ZM7.8562 7.32227L7.80054 7.37305V7.26172L7.8562 7.32227ZM4.27515 4.30078L4.09058 4.10352L4.27515 3.93164V4.30078ZM7.87964 4.10352L7.80054 4.1875V4.0293L7.87964 4.10352Z"
      fill={color}
      fillOpacity="0.66"
    />
  </svg>
);
